

































































































































































































































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { timeFormat } from "@/utils/index.ts";
import { ticketClient } from "@/api/index";
import {
  GetBasicTicketAttrsReq,
  GetTicketAttrFuncReq,
  GetTicketAttrsReq,
  SaveTicketAttrReq,
  GetTicketAttrsOptionReq,
} from "@/pbjs/external/ticket/ticket_pb";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, errorMsg, setPage } from "@/utils/request";

@Component({
  name: "CombinationProperty",
})
export default class CombinationProperty extends Vue {
  @Provide() private resultData: any = [];
  @Provide() private token: any = "";
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private searchText: string = "";
  @Provide() private application: number = 100;
  @Provide() private operation: any = [];
  @Provide() private logicOperation: any = [];
  @Provide() private onOperateValues: string[] = [];
  @Provide() private basicAttrOptions: any = [];
  @Provide() private basicAttrList: any = [];
  @Provide() private basicAttrMap: any = new Map();
  @Provide() private isShowAttrValue: boolean = false;
  @Provide() private isShowCombValue: boolean = false;
  @Provide() private userId: any;
  @Provide() private combFirstValueOptions: any = [];
  @Provide() private typeInput: boolean = true;
  @Provide() private isEdit: boolean = false;
  @Provide() private isEditId: number = 0;
  @Provide() private applicationOption: any = [];
  @Provide() private attrValueForm: any = {
    attrValueName: "",
    singleOnOperateValues: "",
    basicAttrListValue: "",
    basicAttrValue: undefined,
    systemType: "",
  };
  @Provide() private combForm: any = {
    combLoginName: "",
    combFirstValue: "",
    combination: [{ operation: "", input: "" }],
  };
  @Provide() private attrValueRules: any = {
    attrValueName: [{ required: true, message: "请输入", trigger: "blur" }],
    basicAttrValue: [{ required: true, message: "请输入", trigger: "blur" }],
  };
  @Provide() private combRules: any = {
    combLoginName: [{ required: true, message: "请输入", trigger: "blur" }],
    combFirstValue: [{ required: true, message: "请输入", trigger: "blur" }],
  };
  @Provide() private isSearchCombValueDone: boolean = false;
  @Provide() private pagnition: any = pagnition;

  private created() {
    this.token = localStorage.getItem("token");
    this.userId = localStorage.getItem("userid");
    this.getBasicTicketAttrs();
    this.getTicketAttrs();
    this.getTicketAttrFunc(1);
    this.getTicketAttrFunc(2);
    this.getTicketAttrsOption();
    this.getApplicationOption();
  }
  private getApplicationOption() {
    this.applicationOption = [
      { value: 0, label: this.$t("ticketFhb.urgeDistribution") },
      { value: 1, label: this.$t("ticketFhb.verifyDistribution") },
      { value: 2, label: this.$t("ticketLgy.TelemarketingDistribution") },
      { value: 100, label: this.$t("ticketLgy.All") },
    ];
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getTicketAttrs();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getTicketAttrs();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getTicketAttrs();
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getTicketAttrs();
  }

  private resetForm(formName: string) {
    let ref: any = this.$refs[formName];
    if (ref) {
      ref.resetFields();
    }
    if (this.isShowCombValue) {
      this.combForm.combination = [{ operation: "", input: "" }];
    }
  }

  private submitForm() {
    let formName: string = "";
    if (this.isShowAttrValue) {
      formName = "attrValueForm";
    } else {
      formName = "combForm";
    }
    let ref: any = this.$refs[formName];
    ref.validate((valid: any) => {
      if (valid) {
        this.submitOperation();
      } else {
        return false;
      }
    });
  }

  private deleteCombItem(index: number) {
    this.combForm.combination.splice(index, 1);
  }

  private searchCombValue() {
    this.isSearchCombValueDone = true;
    this.pageIndex = 1;
    this.getTicketAttrs();
  }

  private addAttrValueOperation() {
    this.isShowAttrValue = true;
    this.isShowCombValue = false;
    if (this.isEditId) {
      this.isEditId = 0;
    }
    this.resetForm("attrValueForm");
  }

  private addCombAttrOperation() {
    this.isShowAttrValue = false;
    this.isShowCombValue = true;
    this.isEditId = 0;
    this.resetForm("combForm");
  }

  private submitOperation() {
    if (this.isShowAttrValue) {
      this.saveTicketAttr();
    }
    if (this.isShowCombValue) {
      this.saveCombTicketAttr();
    }
  }

  private editCombination(row: any) {
    if (row.func) {
      this.isShowAttrValue = true;
      this.isShowCombValue = false;
      this.attrValueForm.attrValueName = row.name;
      this.attrValueForm.basicAttrValue = Number(row.value);
      this.attrValueForm.singleOnOperateValues = row.func;
      this.attrValueForm.systemType = row.systemtype;
      this.isEditId = row.id;
      this.attrValueForm.basicAttrListValue = row.funcparam + "";
      // this.isEdit = true;
    } else {
      this.isShowCombValue = true;
      this.isShowAttrValue = false;
      this.combForm.combLoginName = row.name;
      let value: any = row.value;
      this.isEditId = row.id;
      value = value.split(" ");
      this.combForm.combination = [];
      value.forEach((item: any, index: number) => {
        if (index == 0) {
          this.combForm.combFirstValue = item.trim();
        } else if (index % 2 == 1) {
          this.combForm.combination.push({
            operation: item.trim(),
            input: value[index + 1],
          });
        }
      });
    }
  }

  private addOneCombination() {
    this.combForm.combination.push({ operation: "", input: "" });
  }

  private combRlueString(): string | number {
    let str: string | number = this.combForm.combFirstValue;
    this.combForm.combination.forEach((item: any) => {
      str = str + " " + item.operation + " " + item.input;
    });
    return str;
  }

  @Watch("attrValueForm.basicAttrValue")
  onBasicAttrValueChanged(val: number | string) {
    if (this.basicAttrMap.get(val)) {
      this.typeInput = false;
      // this.attrValueForm.basicAttrListValue = "";
      this.attrValueForm.singleOnOperateValues = this.basicAttrMap.get(val).func.func;
      this.basicAttrList = this.basicAttrMap.get(val).funcparamList;
    } else {
      this.typeInput = true;
      // this.attrValueForm.basicAttrListValue = "";
    }
  }

  private getBasicTicketAttrs() {
    let request: any = new GetBasicTicketAttrsReq();
    request.setCommonin(setCommon());
    request.setAttrtype(0);
    request.setPagein(setPage(this.pageIndex, this.pageSize));
    request.setFiltername(this.searchText);
    ticketClient.getBasicTicketAttrs(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          if (data.listList) {
            this.basicAttrOptions = data.listList;
          }
          let map = new Map(data.funcoptionMap);
          this.basicAttrMap = map;
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private getTicketAttrFunc(operationType: number) {
    let request: any = new GetTicketAttrFuncReq();
    request.setCommonin(setCommon());
    request.setFunctype(operationType);
    ticketClient.getTicketAttrFunc(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (data.listList) {
          if (operationType == 1) {
            this.operation = data.listList;
          }
          if (operationType == 2) {
            this.logicOperation = data.listList;
          }
        }
        if (!data.commonout || data.commonout.code == 0) {
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private getTicketAttrs() {
    let request: any = new GetTicketAttrsReq();
    request.setCommonin(setCommon());
    request.setPagein(setPage(this.pageIndex, this.pageSize));
    request.setName(this.searchText);
    request.setSystemtype(this.application);
    ticketClient.getTicketAttrs(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          this.pagerCount = data.pageout.total;
          data.listList.forEach((item: any) => {
            item.ctime = timeFormat(item.ctime);
          });
          this.resultData = data.listList;
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
      this.isSearchCombValueDone = false;
    });
  }

  private getTicketAttrsOption() {
    let request: any = new GetTicketAttrsOptionReq();
    request.setCommonin(setCommon());
    ticketClient.getTicketAttrsOption(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          this.combFirstValueOptions = data.listList;
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private saveTicketAttr() {
    let request: any = new SaveTicketAttrReq();
    request.setCommonin(setCommon());
    request.setAttrtype(2);
    request.setName(this.attrValueForm.attrValueName);
    request.setValue(this.attrValueForm.basicAttrValue + "");
    request.setFunc(this.attrValueForm.singleOnOperateValues);
    request.setFuncparam(this.attrValueForm.basicAttrListValue);
    request.setSystemtype(+this.attrValueForm.systemType);
    request.setId(this.isEditId);
    ticketClient.saveTicketAttr(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          this.getTicketAttrs();
          this.$message({
            message: "submit successfully",
            type: "success",
          });
          this.resetForm("attrValueForm");
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private saveCombTicketAttr() {
    let request: any = new SaveTicketAttrReq();
    request.setCommonin(setCommon());
    request.setId(this.isEditId);
    request.setAttrtype(2);
    request.setName(this.combForm.combLoginName);
    request.setValue(this.combRlueString());
    ticketClient.saveTicketAttr(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          this.getTicketAttrs();
          this.$message({
            message: "提交成功",
            type: "success",
          });
          this.resetForm("combForm");
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
}
